exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chapter-nav[data-v-1756d99e] {\n}\n.materials[data-v-1756d99e] {\n    border-bottom: 1px solid #aaaaaa;\n}\n.disabled-link[data-v-1756d99e] { \n    cursor: not-allowed;\n}\n", ""]);

// exports
